// extracted by mini-css-extract-plugin
export default {"component":"toiletCheckQuestionDialog__component___30NhR"};